import React from "react";
import { SubjectsDashboardContainer } from "./SubjectsDashboard.style";
import Header from "Components/Header/Header";
import Footer from "../Footer/Footer";
import PageHeading from "Components/PageHeading/PageHeading";
import SubjectsIntro from "./SubjectsIntro";

// Import typography styles
import "../../Styles/typography.css";
import MobileHeader from "Components/Header/MobileHeader";
import SubjectsOverview from "./SubjectsOverview";

const SubjectsDashboard = () => {
	return (
		<SubjectsDashboardContainer className="">
			<Header />
			<MobileHeader />
			<PageHeading
				title={
					<>
						Our <span className="redfont">Subjects</span>
					</>
				}
				breadcrumbs={[{ label: "Home", path: "/" }, { label: "Subjects" }]}
			/>
			<SubjectsIntro />
			<SubjectsOverview />
			<Footer />
		</SubjectsDashboardContainer>
	);
};

export default SubjectsDashboard;
